/**
 * Commands API adapter layer.
 * Wraps the BFF-based device.api.ts listCommandHistory function.
 */
import type { Command } from '../types/command.types'
import type { CommandHistoryItem } from './device.types'
import { listCommandHistory } from './device.api'

interface CommandHistoryResponse {
  items: Command[]
  hasMore: boolean
  nextCursor?: string
  prevCursor?: string
}

function mapCommandItem(item: CommandHistoryItem): Command {
  return {
    id: item.id,
    type: item.type,
    deviceId: item.deviceId,
    createdBy: item.createdBy,
    status: item.status,
    message: {
      message: (item.message as Record<string, unknown>)?.message as string || '',
      ...(item.message as Record<string, unknown>),
    },
    result: item.result,
    errorMessage: item.errorMessage,
    createdAt: item.createdAt,
    receivedAt: item.receivedAt,
    executedAt: item.executedAt,
  }
}

export async function getByDevice(
  deviceId: string,
  params?: { status?: string; limit?: number; cursor?: string }
): Promise<CommandHistoryResponse> {
  const resp = await listCommandHistory({
    deviceId,
    limit: params?.limit ?? 20,
    cursor: params?.cursor,
    status: params?.status,
  })
  return {
    items: resp.items.map(mapCommandItem),
    hasMore: resp.hasMore,
    nextCursor: resp.nextCursor,
    prevCursor: resp.prevCursor,
  }
}
